import { ValueOf } from '@ahha/utils/@types/typeUtils'

export const MODEL_TYPES = {
  ANOMALY_DETECTION: 'ANOMALY_DETECTION',
  SEGMENTATION: 'SEGMENTATION',
  CLASSIFICATION: 'CLASSIFICATION',
  OBJECT_DETECTION: 'OBJECT_DETECTION',
  IMAGE_ENHANCEMENT: 'IMAGE_ENHANCEMENT',
  OCR: 'OCR',
  REGRESSION_TABULAR: 'REGRESSION_TABULAR',
  // VIDEO: 5,
  // TABULAR: 6,
} as const

export const TRAINING_MODEL_TYPES = {
  ANOMALY_MEDIUM: 'MEDIUM',
  ANOMALY_SMALL: 'SMALL',
  ANOMALY_LARGE: 'LARGE',
  SEGMENTATION: 'SEGMENTATION', // 미사용
  CLASSIFICATION: 'CLASSIFICATION', // 미사용
  CLASSIFICATION_CONVNEXT_T: 'CONVNEXT_T',
  CLASSIFICATION_CONVNEXT_B: 'CONVNEXT_B',
  CLASSIFICATION_LARGE: 'MMCLS_LARGE',
  OBJECT_DETECTION: 'OBJECT_DETECTION', // 미사용
  OBJECT_DETECTION_RT_DETR: 'MMDET_RT',
  OBJECT_DETECTION_YOLOX: 'MMDET_YOLOX',
  IE_VIT: 'VIT',
  IE_CNN: 'CNN',
  IE_CNN_MEDIUM: 'CNN_MEDIUM',
  OCR: 'OCR', // 미사용
  SERIES_TRANSFORMER: 'transformer',
  SERIES_LSTM: 'LSTM',
  SERIES_CATBOOST: 'CatBoost',
  SERIES_XGBOOST: 'XGBoost',
  SERIES_LGBM: 'LGBM',
  SERIES_REGRESSION: 'Regression',
}
export type ModelValueType = ValueOf<typeof MODEL_TYPES>
export type TrainingModelValueType = ValueOf<typeof TRAINING_MODEL_TYPES>
export const MODEL_LABELS: Record<string, string> = {
  ANOMALY_DETECTION: 'common_anomalyDetection',
  SEGMENTATION: 'common_segmentation',
  CLASSIFICATION: 'common_classification',
  OBJECT_DETECTION: 'common_objectDetection',
  IMAGE_ENHANCEMENT: 'common_imageEnhancement',
  OCR: 'common_ocr',
  REGRESSION_TABULAR: 'common_regression',
}

export const HYPER_PARAMETER_TYPES = {
  ANOMALY_DETECTION_SMALL: 'ANOMALY_DETECTION_SMALL',
  ANOMALY_DETECTION_MEDIUM: 'ANOMALY_DETECTION_MEDIUM',
  ANOMALY_DETECTION_LARGE: 'ANOMALY_DETECTION_LARGE',
  SEGMENTATION: 'SEGMENTATION',
  CLASSIFICATION: 'CLASSIFICATION',
  CLASSIFICATION_CONVNEXT_T: 'CLASSIFICATION_CONVNEXT_T',
  CLASSIFICATION_CONVNEXT_B: 'CLASSIFICATION_CONVNEXT_B',
  CLASSIFICATION_LARGE: 'CLASSIFICATION_LARGE',
  OBJECT_DETECTION: 'OBJECT_DETECTION',
  IMAGE_ENHANCEMENT_CNN: 'IMAGE_ENHANCEMENT_CNN',
  IMAGE_ENHANCEMENT_CNN_MEDIUM: 'IMAGE_ENHANCEMENT_CNN_MEDIUM',
  IMAGE_ENHANCEMENT_VIT: 'IMAGE_ENHANCEMENT_VIT',
  OCR: 'OCR',
  SERIES_TRANSFORMER: 'SERIES_TRANSFORMER',
  SERIES_LSTM: 'SERIES_LSTM',
  SERIES_CATBOOST: 'SERIES_CATBOOST',
  SERIES_XGBOOST: 'SERIES_XGBOOST',
  SERIES_LGBM: 'SERIES_LGBM',
  SERIES_AD_TRANSFORMER: 'SERIES_AD_TRANSFORMER',
  TABULAR_CLS_TRANSFORMER: 'TABULAR_CLS_TRANSFORMER',
  TABULAR_CLS_LSTM: 'TABULAR_CLS_LSTM',
  TABULAR_CLS_CATBOOST: 'TABULAR_CLS_CATBOOST',
  TABULAR_CLS_XGBOOST: 'TABULAR_CLS_XGBOOST',
  // TABULAR_CLS_LGBM: 'TABULAR_CLS_LGBM',
  TABULAR_AD_TRANSFORMER: 'TABULAR_AD_TRANSFORMER',
  TABULAR_REGRESSION_TRANSFORMER: 'TABULAR_REGRESSION_TRANSFORMER',
  TABULAR_REGRESSION_LSTM: 'TABULAR_REGRESSION_LSTM',
  TABULAR_REGRESSION_XGBOOST: 'TABULAR_REGRESSION_XGBOOST',
} as const
export type HyperParameterType = ValueOf<typeof HYPER_PARAMETER_TYPES>

export const TRAINING_MODEL_I18N_KEYS: Record<string, string> = {
  ANOMALY_DETECTION_MEDIUM: 'model_anomalyDetection_medium',
  ANOMALY_DETECTION_SMALL: 'model_anomalyDetection_small',
  SEGMENTATION: 'model_segmentation',
  CLASSIFICATION: 'model_classification',
  CLASSIFICATION_CONVNEXT_T: 'timm/convnext_tiny.fb_in22k_ft_in1k_384',
  CLASSIFICATION_CONVNEXT_B: 'timm/convnext_base.fb_in22k_ft_in1k_384',
  OBJECT_DETECTION: 'model_objectDetection',
  IMAGE_ENHANCEMENT_CNN: 'model_settings_imageEnhancement_CNN',
  IMAGE_ENHANCEMENT_VIT: 'model_settings_imageEnhancement_ViT',
  IMAGE_ENHANCEMENT_CNN_MEDIUM: 'model_settings_imageEnhancement_CNN_medium',
  OCR: 'model_ocr',
}

export const EVALUATION_TYPES = {
  TRAIN: 'TRAIN',
  VALIDATION: 'VALIDATION',
  INFERENCE: 'INFERENCE',
  PIPELINE_RESULT: 'PIPELINE_RESULT',
} as const
export type EvaluationValueType = ValueOf<typeof EVALUATION_TYPES>

export const MODEL_COLORS = {
  ANOMALY_DETECTION: '#1FB356',
  SEGMENTATION: '#F97316',
  CLASSIFICATION: '#F2BC1A',
  OBJECT_DETECTION: '#1A75FF',
  IMAGE_ENHANCEMENT: '#CEB0FA',
  OCR: '#3DD3ED',
  REGRESSION_TABULAR: '#F2BC1A', // FIXME: 컬러
}

export const TASK_STATUS_TYPES = {
  CREATED: 'CREATED',
  PREPARING: 'PREPARING',
  WAITING: 'WAITING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  PAUSING: 'PAUSING',
  PAUSED: 'PAUSED',
  RESUMED: 'RESUMED',
  CANCELED: 'CANCELED',
  TERMINATED: 'TERMINATED',
  ERROR: 'ERROR',
  TIMEOUT: 'TIMEOUT',
  UNKNOWN: 'UNKNOWN',
  STOPPING: 'STOPPING',
  PENDING: 'PENDING',
  BLOCKED: 'BLOCKED',
  INSUFFICIENT_CREDIT: 'INSUFFICIENT_CREDIT',
} as const
export type TaskStatusValueType = ValueOf<typeof TASK_STATUS_TYPES>

export const COMPLETED_TASKS: TaskStatusValueType[] = [
  TASK_STATUS_TYPES.COMPLETED,
  TASK_STATUS_TYPES.STOPPING,
]

export const ERROR_TASKS: TaskStatusValueType[] = [
  TASK_STATUS_TYPES.ERROR,
  TASK_STATUS_TYPES.TIMEOUT,
  TASK_STATUS_TYPES.UNKNOWN,
]
export const RUNNING_TASKS: TaskStatusValueType[] = [
  TASK_STATUS_TYPES.CREATED,
  TASK_STATUS_TYPES.PREPARING,
  TASK_STATUS_TYPES.WAITING,
  TASK_STATUS_TYPES.RUNNING,
  TASK_STATUS_TYPES.RESUMED,
  TASK_STATUS_TYPES.STOPPING,
]

export const WAITING_RESULT_TASKS: TaskStatusValueType[] = [
  TASK_STATUS_TYPES.PAUSING, // 일시정지 버튼 누르고 paused 되기 전까지
  TASK_STATUS_TYPES.RESUMED, // 재개 버튼 누르고 running 되기 전까지
  TASK_STATUS_TYPES.STOPPING, // 중지 버튼 누르고 completed 되기 전까지
]

export const MAX_NODE_NAME_LENGTH = 80
export const MAX_PROJECT_NAME_LENGTH = 60

export const LABELING_BLOCKING_TYPES = {
  EDITING_BLOCKED: 'editingBlocked', // 모델 재학습시, 자동생성된 라벨링 노드에서 수동 검수 체크 안한 경우
  NODE_COMPLETED: 'nodeCompleted',
  REVIEW_ONGOING: 'reviewOngoing',
  REVIEW_PENDING: 'reviewPending',
  PERMISSION: 'permission',
  FINISHED: 'finished',
  COMPLETED: 'completed',
  NO_CLASS: 'noClass',
} as const

export type LabelingBlockingType = ValueOf<typeof LABELING_BLOCKING_TYPES> | null

export const EXCLUDE_EMAIL_LIST = [/@gmail\.com/, /@yahoo\.com/, /@naver\.com/, /@daum\.net/, /@outlook\.com/, /@hotmail\.com/, /@protonmail\.com/, /@icloud\.com/, /@mail\.com/, /@kakao\.com/, /@hanmail\.net/]

export const FORBIDDEN_NODE_NAME_CHARS = /[₩/:*?"<>|\\]/

// 사용자 이름 규칙. 한글, 영문, 공백만 허용
export const NAME_VALIDATION_REGEX = /^[a-zA-Z가-힣ㄱ-ㅎㅏ-ㅣ\s]+$/

// Time Series / Tabular processing task type
export const TABULAR_REQUEST_STATUS = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  COMPLETED: 'COMPLETED',
  ERROR: 'ERROR',
}
export type TabularRequestStatusType = ValueOf<typeof TABULAR_REQUEST_STATUS>
